import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import {AlertModule} from './../../common/alert/alert.module';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatLegacySliderModule as MatSliderModule} from '@angular/material/legacy-slider';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';

import { AssessmentSummaryRoutingModule } from './assessment-summary-routing.module';
import { AssessmentReviewerSummaryComponent } from './assessment-reviewer-summary/assessment-reviewer-summary.component';
import { AssessmentEmailSummaryComponent } from './assessment-email-summary/assessment-email-summary.component';

@NgModule({
  declarations: [AssessmentReviewerSummaryComponent, AssessmentEmailSummaryComponent],
  imports: [
    CommonModule,
    AssessmentSummaryRoutingModule,
    TabsModule.forRoot(),
    NgbModule,
    MatCardModule,
    MatSliderModule,
    MatSidenavModule,
    MatProgressBarModule,
    CollapseModule.forRoot(),
    NgxPaginationModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskPipe,
    NgxMaskDirective,
    AlertModule,
    MatCheckboxModule,
    MatTableModule
  ],
  exports: [
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatRadioModule,
    MatTableModule,
    AssessmentReviewerSummaryComponent
  ],
})
export class AssessmentSummaryModule { }
